import React, { useState, useCallback, memo } from 'react';
import classNames from 'classnames';

import { UiButton } from 'src/components/UI/Button';
import { UserModel } from 'src/models/Account/User';
import { useRefClickOutside } from 'src/utils/hooks/useRefClickOutside';
import { HeaderUserPopupContent } from './UserPopup';

const Avatar = memo(({ user, toggle }: { user: UserModel; toggle: () => void }) => (
  <UiButton
    tag="a"
    onClick={toggle}
    dataTest="avatarIcon"
    className={classNames('waves-effect waves-light header-user-info hoverable generated-avatar', {
      withPhoto: !!user.imageUri,
      'HeaderIconColorBg no-avatar': !user.imageUri,
    })}
  >
    {user.imageUri ? (
      <img className="img-circle" alt="" src={user.imageUri} />
    ) : (
      user.lastName &&
      user.firstName && (
        <span className="initials text-uppercase d-b">
          {user.firstName[0]}
          {user.lastName[0]}
        </span>
      )
    )}
  </UiButton>
));

type AuthenticatedUserIconProps = {
  user: UserModel;
};

export const HeaderAuthenticatedUserIcon: React.FC<AuthenticatedUserIconProps> = memo(
  ({ user }: AuthenticatedUserIconProps) => {
    const [popupShown, setPopupShown] = useState(false);

    const hidePopover = useCallback(() => {
      setPopupShown(false);
    }, []);

    const toggle = useCallback(() => {
      setPopupShown((v) => !v);
    }, []);

    const ref = useRefClickOutside<HTMLLIElement>(popupShown, hidePopover);

    return (
      <li ref={ref} className="header-user-authenticated-icon">
        <Avatar user={user} toggle={toggle} />

        <div
          className={classNames('popover not-custom-branding-popover my-account-popover', {
            show: popupShown,
          })}
          onBlur={hidePopover}
        >
          {popupShown && <HeaderUserPopupContent user={user} onClose={hidePopover} />}
        </div>
      </li>
    );
  }
);
